import React from "react";
import { BsBriefcaseFill } from "react-icons/bs";
import Layout from "./Layout";
import { VscLayoutActivitybarLeft } from "react-icons/vsc";
import { PiStudentBold } from "react-icons/pi";
import Faq2 from "./components/Faq2";
const Curriculum = () => {
    return (
        <Layout>
            <div className="text-[#0a1a42] mt-12 md:mt-24">
                <div>

                    <div className="px-4 md:flex  md:justify-evenly" >
                        <div className="">
                            <h1 className="text-[#0a1a42] text-3xl font-bold text-center font-roboto">Curriculum And Approach.</h1>
                            <h4 className="leading-7 text-lg mt-4">
                                DRIC consistently ranks among the very best Nigerian secondary schools
                                in student satisfaction which is clear evidence of the quality of teaching
                                and the quality of the overall educational experience one gains at DRIC.
                            </h4>
                            <div className="flex md:justify-center space-x-8 font-roboto mt-8">
                                <button className="py-3 px-6 bg-[#f7951e] text-white">
                                    Get Started
                                </button>
                                <button className="py-3 px-6 border-2 text-sm border-[#f7951e]">
                                    Admissions Page
                                </button>

                            </div>
                        </div>
                        <div className="mt-8 ">
                            <img src="/schoolweb/curi.webp" alt="" className="md:w-3/4" />
                        </div>
                    </div>

                    <div className="md:flex md:px-0 mt-24  text-[#0a1a42] md:mt-24 justify-evenly">
                        <div className="bg-blue-100 md:px-8 md:py-4  max-[760px]:text-center">
                            <h2 className="text-2xl font-roboto pt-4">DEPARTMENTS OF STUDY </h2>

                            <ul className="max-w-md text-xl max-[760px]:mx-auto max-[760px]:py-4 space-y-1 text-gray-500 list-inside dark:text-gray-400">
                                <li className="flex items-center">
                                    <svg className="w-3.5 h-3.5 mr-2 text-[#f7951e] flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                    </svg>
                                    Mathematics department
                                </li>
                                <li className="flex items-center">
                                    <svg className="w-3.5 h-3.5 mr-2 text-[#f7951e] flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                    </svg>
                                    Science department
                                </li>
                                <li className="flex items-center">
                                    <svg className="w-3.5 h-3.5 mr-2 text-[#f7951e] flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                    </svg>
                                    Language department
                                </li>
                                <li className="flex items-center">
                                    <svg className="w-3.5 h-3.5 mr-2 text-[#f7951e] flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                    </svg>
                                    Arts department
                                </li>
                                <li className="flex items-center">
                                    <svg className="w-3.5 h-3.5 mr-2 text-[#f7951e] flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                    </svg>
                                    Vocational department
                                </li>
                                <li className="flex items-center">
                                    <svg className="w-3.5 h-3.5 mr-2 text-[#f7951e] flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                    </svg>
                                    Commercial department
                                </li>
                            </ul>
                        </div>

                        <div className="text-[#0a1a42] md:w-2/4 mt-4 px-4">
                            <h2 className="text-2xl font-roboto md:text-4xl font-bold">
                                A Love For Learning
                            </h2>

                            <p>
                                <h2>
                                    At DRIC, we believe that every child’s life can be positively
                                    transformed by an inspirational teacher irrespective of the
                                    child’s physical, mental, and emotional background. We are particular
                                    about this virtue when we recruit and train our teachers. The passion,
                                    commitment, and kindness exhibited by our professional staff body, to our students,
                                    parents, and stakeholders explain why Divine Royal International College is now one of
                                    the highest-performing schools in Nigeria
                                </h2>
                                <h3>
                                    With the growing reliance on entrepreneurship, DRIC introduced
                                    Vocation Centre (Centre For Skill Acquisition ), rendering global
                                    standard Vocational courses to raise a generation of astute entrepreneurs.
                                </h3>
                            </p>

                        </div>
                    </div>



                    <div>



                        <div className="grid mb-8 md:mt-24 max-[760px]:mt-8 border border-gray-200 rounded-lg shadow-sm    md:mb-12 md:grid-cols-3">
                            <figure className="flex flex-col items-center justify-center p-8 text-center bg-white border-b border-gray-200 rounded-b-lg md:rounded-br-lg ">
                                <figcaption className="flex items-center justify-center space-x-3">
                                    <PiStudentBold className="rounded-full text-[#f7951e] w-9 h-9 " />
                                </figcaption>
                                <blockquote className="max-w-2xl mx-auto mb-4 text-gray-500 lg:mb-8 dark:text-gray-400">
                                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Academic Excellence</h3>
                                    <p className="my-4">
                                        The school operates a dual curriculum combining the
                                        British curriculum with that of its host country Nigeria,
                                        giving our students a competitive advantage over their
                                        peers.
                                    </p>
                                </blockquote>
                            </figure>

                            <figure className="flex flex-col items-center justify-center p-8 text-center bg-white border-b border-gray-200 rounded-tr-lg ">
                                <figcaption className="flex items-center justify-center space-x-3">
                                    <VscLayoutActivitybarLeft className="rounded-full text-[#f7951e] w-9 h-9" />
                                </figcaption>
                                <blockquote className="max-w-2xl mx-auto mb-4 text-gray-500 lg:mb-8 ">
                                    <h3 className="text-lg font-semibold text-gray-900 ">Extracurricular Activities</h3>
                                    <p className="my-4">
                                        We offer creative and applicable education as we develop and nurture world leaders
                                        and captains of industries. From excursions to National & International Trips and More.
                                    </p>
                                </blockquote>

                            </figure>
                            <figure className="flex flex-col items-center justify-center p-8 text-center bg-white border-b border-gray-200 rounded-bl-lg md:border-b-0 md:border-r dark:0 dark:y-700">
                                <figcaption className="flex items-center justify-center space-x-3">
                                    <BsBriefcaseFill className="rounded-full text-[#f7951e] w-9 h-9 " />

                                </figcaption>
                                <blockquote className="max-w-2xl mx-auto mb-4 text-gray-500 lg:mb-8 ">
                                    <h3 className="text-lg font-semibold text-gray-900 ">Entrepreneurship Development</h3>
                                    <p className="my-4">
                                        With the growing reliance on entrepreneurship, DRIC introduced
                                        a Centre For Skill Acquisition, rendering global standard Vocational
                                        courses to raise astute entrepreneurs.
                                    </p>
                                </blockquote>
                            </figure>
                        </div>



                        {/* <div className="">
                            <h1 className="text-[#0a1a42] text-xl font-bold font-serif">A Love For Learning</h1>
                            <h4>
                                At DRIC, we believe that every child’s life can be positively transformed
                                by an inspirational teacher irrespective of the child’s physical, mental,
                                and emotional background. We are particular about this virtue when we
                                recruit and train our teachers. The passion, commitment, and kindness
                                exhibited by our professional staff body, to our students, parents, and
                                stakeholders explain why Divine Royal International College is now one of
                                the highest-performing schools in Nigeria.
                            </h4>
                            <h4>
                                With the growing reliance on entrepreneurship, DRIC introduced
                                Vocation Centre (Centre For Skill Acquisition ), rendering global
                                standard Vocational courses to raise a generation of astute entrepreneurs.
                            </h4>
                        </div> */}



                    </div>


                    <div className="md:mt-24 mt-12">
                        <Faq2 />
                    </div>


                    <div className="md:mt-24 mt-12">
                        <h1
                            tyle={{
                                width: '100%',
                                height: '40px',
                                scrollBehavior: 'alternate',
                                direction: 'right',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                            }}
                            className="text-center text-[#0a1a42] font-serif font-bold text-2xl">Educational Affiliations</h1>
                        <marquee>
                            <div className="flex">
                                <img src="/schoolweb/marquee/1.webp" alt="" />
                                <img src="/schoolweb/marquee/2.webp" alt="" />
                                <img src="/schoolweb/marquee/3.webp" alt="" />
                                <img src="/schoolweb/marquee/4.webp" alt="" />
                            </div>

                        </marquee>

                        <div>

                        </div>
                    </div>



                </div>
            </div>
        </Layout>
    );
};

export default Curriculum;
